/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { GET_ME, GET_ALL_USERS, GET_TOTAL_UNREAD, GET_CALLING_ACCEPT, GET_CALLING_REJECT, JITSI_CALL_MERGE } from '../../graphql/GraphqlQueries';
import { LeftSection } from "./LeftSection";
import { useQuery, useLazyQuery } from '@apollo/client';
import { useDispatch } from "react-redux";
import { setCountersData, set_user, set_downgrade_popup, set_downgrade_popup_type, setSubscriptionCheck } from "../../redux/message";
import SocketClient from "../../services/SocketClient";
import CallRinging from "../Call_window/Popup/CallRinging";
import GroupCallPopup from "../Call/GroupCallPopup";
import SubscriptionDowngrade from "../Room/SubscriptionDowngrade";
import PageSkeleton from "../Skeleton/PageSkeleton";
import { Toaster } from "react-hot-toast";
import Header from "./Header";
import Downloading from "./Messages/Downloading";

const routePermissions = [
    { pathPrefix: '/connect/daily-report', permission: 'sales' },
    { pathPrefix: '/connect/file_hub', permission: 'file' },
    { pathPrefix: '/connect/tasks', permission: 'task' },


    // add more routes/permissions as needed
];

export const Connect = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const { loading: initialLoading, error: initialError, data: initialData } = useQuery(GET_ME);
    const [fetchUsers, { loading: usersLoading, error: usersError, data: usersData }] = useLazyQuery(GET_ALL_USERS);
    const { loading: counterLoading, error: counterError, data: counterData } = useQuery(GET_TOTAL_UNREAD);
    const callringpopup = useSelector(state => state.message.callringpopup);
    const updateVersion_data = useSelector(state => state.message.updateVersion_data);
    const active_conv = useSelector(state => state.message.active_conversation);
    const downgrade_popup = useSelector(state => state.message.downgrade_popup);
    const downgrade_popup_type = useSelector(state => state.message.downgrade_popup_type);
    const downloading_progress = useSelector(state => state.message.downloading_progress);
    // const subscriptionCheck = useSelector(state => state.message.subscriptionCheck);
    const [getCallingAccept] = useLazyQuery(GET_CALLING_ACCEPT);
    const [getCallingReject] = useLazyQuery(GET_CALLING_REJECT);
    const [getCallingMerge] = useLazyQuery(JITSI_CALL_MERGE);

    const [, setCallRinging] = useState(false);

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState(false);
    useEffect(() => {
        window.dispatchEvent(new Event('beforeinstallprompt'));
        // --- Event Handlers defined inside useEffect to access setDeferredPrompt ---
        // Handler for when the browser is ready to prompt for install
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            // Store the event object globally for the click handler
            window.deferredPrompt1 = e;
            console.log('pwa:beforeinstallprompt fired, showing button.');

            // Set state to true to make the "Install" button appear
            setDeferredPrompt(true);
        };

        // Handler for when the user successfully installs the PWA
        const handleAppInstalled = () => {
            console.log('pwa:appinstalled fired, hiding button.');
            window.deferredPrompt1 = null;

            // Set state to false to hide the "Install" button
            setDeferredPrompt(false);
        };

        // --- Attach Listeners ---
        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', handleAppInstalled);

        // --- Cleanup Function ---
        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', handleAppInstalled);
        };
    }, []);

    useEffect(() => {
        // debugger
        if (!initialData?.me?.access || !Array.isArray(initialData?.me?.access)) return;

        const pathname = location.pathname;
        for (const route of routePermissions) {
            if (pathname.startsWith(route.pathPrefix) && !initialData?.me?.access.includes(route.permission)) {
                navigate(`/connect/${initialData?.me?.id}`);
                break;
            }
        }
    }, [initialData?.me?.access, location.pathname]);


    // useEffect(() => {
    //     if (!active_conv) {
    //         const last_conv = localStorage.getItem('last_active_conv');
    //         if (last_conv) {
    //             navigate(`/connect/${last_conv}`);
    //         }
    //     }
    // }, [active_conv, navigate]);



    useEffect(() => {
        if (initialData?.me) {
            localStorage.removeItem('role');
            localStorage.removeItem('company_id');
            localStorage.removeItem('email');
            localStorage.setItem('role', initialData?.me?.role);
            localStorage.setItem('email', initialData?.me?.email);
            localStorage.setItem('company_id', initialData?.me?.company_id);
        }

    }, [initialData]);

    useEffect(() => {
        if (initialData?.me) {
            if (!localStorage.getItem('initialTipsAndTour') && initialData.me.login_total <= 1) {
                localStorage.setItem('initialTipsAndTour', 'true');
            }
            dispatch(set_user(initialData.me));

            // Silently authenticate the local freeli-notifier service if it's running
            const authToken = localStorage.getItem('token');
            if (authToken && initialData.me._id) {
                fetch('http://127.0.0.1:49152/auth', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        userId:      initialData.me._id,
                        authToken,
                        userFullname: initialData.me.fullname || `${initialData.me.first_name || ''} ${initialData.me.last_name || ''}`.trim(),
                        graphqlUrl:  process.env.REACT_APP_BASE_URL + '/workfreeli',
                        webAppOrigin: window.location.origin,
                    }),
                }).catch(() => {}); // silent — notifier may not be installed
            }
        }
    }, [initialData, dispatch]);

    useEffect(() => {
        if (!initialData?.me?._id) return;
        const sendAuth = () => {
            const authToken = localStorage.getItem('token');
            if (!authToken) return;
            fetch('http://127.0.0.1:49152/ping')
                .then(r => r.json())
                .then(json => {
                    if (json.status === 'ok' && (!json.connected || !json.webAppOrigin)) {
                        fetch('http://127.0.0.1:49152/auth', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                userId: initialData.me._id,
                                authToken,
                                userFullname: initialData.me.fullname || `${initialData.me.first_name || ''} ${initialData.me.last_name || ''}`.trim(),
                                graphqlUrl: process.env.REACT_APP_BASE_URL + '/workfreeli',
                                webAppOrigin: window.location.origin,
                            }),
                        }).catch(() => {});
                    }
                })
                .catch(() => {});
        };
        const interval = setInterval(sendAuth, 60_000);
        return () => clearInterval(interval);
    }, [initialData?.me?._id]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!initialData?.me) return;
        const connectPaths = ['/', '/connect', '/connect/'];
        if (connectPaths.includes(location.pathname)) {
            // navigate(`connect/${initialData.me.id}`);
            navigate(`connect/mcp`);
        }
    }, [initialData?.me?.id, location.pathname, navigate]);


    useEffect(() => {
        if (!initialLoading && !initialError && initialData) {
            fetchUsers({ variables: { company_id: initialData.me.company_id } });
        }
    }, [initialLoading, initialError, initialData, fetchUsers]);

    useEffect(() => {
        if (!counterLoading && !counterError && counterData) {
            dispatch(setCountersData(counterData.total_unread));
        }
    }, [counterLoading, counterError, counterData, dispatch]);

    useEffect(() => {
        // Set loading to false when initial data, users data, and counter data are loaded
        if (!initialLoading && !usersLoading && !counterLoading) {
            setLoading(false);
        }
    }, [initialLoading, usersLoading, counterLoading]);

    if (loading) {
        return <div className="loaderMain">
            <p className="pt-8 text-center">Please wait as this might take some time. <br />
                Clearing old browser cache and reloading user data.</p>
        </div>;
    }

    if (initialError || usersError || counterError) {
        return <div>Error occurred. Please try again later.</div>;
    }

    return (
        <div className="app_container">
            <Toaster />
            <SocketClient user={initialData.me} users={usersData?.users} />
            <LeftSection me={initialData.me} deferredPrompt={deferredPrompt} setDeferredPrompt={setDeferredPrompt} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            {Object.keys(downloading_progress).length !== 0 && <Downloading />}
            {callringpopup.status && <CallRinging data={callringpopup} getCallingMerge={getCallingMerge} getCallingAccept={getCallingAccept} getCallingReject={getCallingReject} me={initialData?.me} setCallRinging={setCallRinging} active_conv={active_conv} />}
            {downgrade_popup && (<SubscriptionDowngrade
                type={downgrade_popup_type}
                timeout={downgrade_popup}
                onCancel={() => {
                    dispatch(set_downgrade_popup(''));
                    dispatch(set_downgrade_popup_type(''));
                    // navigate("/connect/subscription-management/downgradeRequest");
                    // setSubscriptionCheck('downgradeRequest');
                }}
                onDowngrade={() => {
                    dispatch(set_downgrade_popup(''));
                    dispatch(set_downgrade_popup_type(''));
                    navigate("/connect/subscription-management/downgradeRequest");
                    // setSubscriptionCheck('downgradeRequest');
                }}
                onConfirm={() => {
                    dispatch(set_downgrade_popup(''));
                    dispatch(set_downgrade_popup_type(''));
                    navigate("/connect/subscription-management")
                }}
            />
            )}
            {/* {groupCallPopup && <GroupCallPopup fetchCalling={fetchCalling} getCallingAccept={getCallingAccept} getCallingReject={getCallingReject} setGroupCallPopup={setGroupCallPopup} active_conv={active_conv} />} */}

            <Suspense fallback={<PageSkeleton />}>
                <div className="right_section w-[calc(100%-380px)] max-xl:w-full h-full float-left relative">
                    {/* <Header /> */}
                    <Outlet context={{ sidebarOpen, setSidebarOpen }} />
                </div>
                {updateVersion_data === "yes" ? (
                    <div className="backwrap">
                        <div className="upgrade_section">
                            <div className="reloadIcon"></div>
                            <div className="upgrade_title"> New application version detected </div>
                            <div className="upgrade_btn">
                                <button
                                    name="upgrade_btn"
                                    onClick={() => window.location.reload(true)}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </Suspense>
        </div>
    );
};
